import { useState } from "react";
import {
  AlterationAgreementType,
  GetAlterationReasonsQuery,
  useGetAlterationReasonsQuery,
  useUpdateLocationMutation,
} from "src/generated/graphql";
import ReasonsList from "./ReasonsList";
import { Flex } from "@mantine/core";
import Switch from "src/components/Switch/Switch";
import { CardRadius, HeightCard } from "src/utils/constants";
import ActionCard from "src/components/ActionCard";
import { GetLocation } from "src/api/graphql/queries/Location";
import { LocationData, useAppContext } from "src/api/AppContext";

type ISettings = {
  locId: string;
  stationsEnabled: boolean;
};
type IReasons = GetAlterationReasonsQuery["alterationReasonMany"];

function Settings({ locId, stationsEnabled }: ISettings) {
  const {
    currentLocation,
    setCurrentLocation,
    currentEmployee,
    currentOrganization,
    setCurrentOrganization,
    setCurrentEmployee,
  } = useAppContext();

  const [cancelData, setcancelData] = useState<IReasons>([]);
  const [freezeData, setfreezeData] = useState<IReasons>([]);
  const { refetch: refetchReasons } = useGetAlterationReasonsQuery({
    variables: { locationId: locId, includeAll: true },
    skip: !locId,
    fetchPolicy: "cache-and-network",
    onCompleted(data) {
      if (!data.alterationReasonMany) return;
      setcancelData(
        data.alterationReasonMany.filter(
          (d) => d.type === AlterationAgreementType.Cancel
        )
      );

      setfreezeData(
        data.alterationReasonMany.filter(
          (d) => d.type === AlterationAgreementType.Freeze
        )
      );
    },
  });

  const [updateLocation, { loading }] = useUpdateLocationMutation({
    onCompleted: (data) => {
      const CurrentLoc = currentLocation as Required<LocationData>;
      // Set current location if its same
      if (CurrentLoc.id === data.updateLocation.id) {
        setCurrentLocation({
          ...CurrentLoc,
          stationsEnabled: data.updateLocation.stationsEnabled,
        });
      }

      // Update Time Station value
      let locationIndex = (
        currentEmployee
          ? currentEmployee?.locations
          : currentOrganization?.locations
      )?.findIndex((loc) => loc.id === data.updateLocation.id);
      if (locationIndex === -1) return;
      if (currentEmployee) {
        currentEmployee.locations[locationIndex!].stationsEnabled =
          data.updateLocation.stationsEnabled;
        setCurrentEmployee({ ...currentEmployee });
      } else if (currentOrganization) {
        currentOrganization.locations[locationIndex!].stationsEnabled =
          data.updateLocation.stationsEnabled;
        setCurrentOrganization({ ...currentOrganization });
      }
    },
    refetchQueries: [{ query: GetLocation, variables: { id: locId } }],
  });

  const handleStationsEnabled = async (e: boolean) => {
    await updateLocation({
      variables: {
        data: {
          stationsEnabled: e,
        },
        id: locId,
      },
    });
  };

  return (
    <Flex direction={"column"} gap={"sm"}>
      <ActionCard
        title={"Time Clock Stations"}
        rightIconButton={null}
        height={HeightCard.sm}
        radius={CardRadius.sm}
        size="md"
      >
        <Switch
          labelPosition="left"
          label="Enable Time Clock Stations"
          checked={stationsEnabled}
          onChange={(e) => handleStationsEnabled(e.target.checked)}
          disabled={loading}
          mt="md"
        />
      </ActionCard>
      <ReasonsList
        reasons={cancelData || []}
        onRefetch={refetchReasons}
        locId={locId}
        type={AlterationAgreementType.Cancel}
        title={"Cancellation Request Reasons"}
      />

      <ReasonsList
        reasons={freezeData || []}
        onRefetch={refetchReasons}
        locId={locId}
        type={AlterationAgreementType.Freeze}
        title={"Freeze Request Reasons"}
      />
    </Flex>
  );
}

export default Settings;
